import { fromPairs } from "lodash";

export * from './ConfigService';
export * from './IConfigService';
